import React from 'react'

export default function LoadingAuth() {
    return (
        <div className="fixed inset-0 z-[9999] flex cursor-progress items-center justify-center bg-white p-4 backdrop-blur-[4px]">
            <div className="flex w-full max-w-[320px] flex-col items-center text-center">
                <div className="relative flex h-16 w-16 items-center justify-center">
                    <div className="absolute inset-0 animate-ping rounded-full bg-[#186cb2]/20" />
                    <div className="relative flex h-14 w-14 items-center justify-center rounded-full border border-[#186cb2]/30 bg-white shadow-lg">
                        <svg className="h-7 w-7 animate-[authPulse_1.6s_ease-in-out_infinite] text-[#186cb2]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <path d="M12 3L19 6V11C19 15.5 16.1 19.2 12 21C7.9 19.2 5 15.5 5 11V6L12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M9.5 12L11.2 13.7L14.8 10.1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                </div>
                <p className="mt-3 text-sm font-semibold text-[#186cb2] drop-shadow-sm">
                    Verifying session
                </p>
                <div className="mt-2 flex items-center justify-center gap-1">
                    <span className="h-1.5 w-1.5 animate-[authDot_1.4s_ease-in-out_infinite] rounded-full bg-[#186cb2]" />
                    <span className="h-1.5 w-1.5 animate-[authDot_1.4s_ease-in-out_0.2s_infinite] rounded-full bg-[#186cb2]" />
                    <span className="h-1.5 w-1.5 animate-[authDot_1.4s_ease-in-out_0.4s_infinite] rounded-full bg-[#186cb2]" />
                </div>
                <p className="mt-2 text-xs font-medium text-[#186cb2]">
                    Checking your authentication
                </p>
                <style>{`
                    @keyframes authPulse {
                        0%, 100% {
                            transform: scale(1);
                            opacity: 0.75;
                        }
                        50% {
                            transform: scale(1.08);
                            opacity: 1;
                        }
                    }
                    @keyframes authDot {
                        0%, 60%, 100% {
                            opacity: 0.3;
                            transform: translateY(0);
                        }
                        30% {
                            opacity: 1;
                            transform: translateY(-3px);
                        }
                    }
                `}</style>
            </div>
        </div>
    );
}